import { FaroErrorBoundary } from '@grafana/faro-react'

export class CustomFaroErrorBoundary extends FaroErrorBoundary {
  constructor(props) {
    super(props)
  }

  componentDidCatch(error, errorInfo) {
    if (typeof api === 'function') {
      super.componentDidCatch(error, errorInfo)
    }
  }
}
